import serverVars from 'server-vars';
import {
    setUserRegionalInfo,
    forceSetUserRegionalInfo,
} from 'dibs-regional-info/exports/setUserRegionalInfo';

// types
import { type Environment } from 'relay-runtime';

/**
 * check and set (if missing) user regional info in sessionStorage
 * this is needed when user opens a new tab, and sessionStorage is still empty
 */
// await is needed here! It's needed to make sure to wait till
// sessionStorage.userGeoInfo has enough data to continue
// this function execution where userZipCode, userCountryCode and hasSessionRegions
// is being set a few lines down

export const setPdpUserRegionalInfo = async ({
    userId,
    environment,
}: {
    userId?: string;
    environment: Environment;
}): Promise<void> => {
    const hasUserLoggedIn = userId && !serverVars.get('userType');
    if (environment) {
        // force regional info reset just for newly logged in users
        if (hasUserLoggedIn) {
            await forceSetUserRegionalInfo({
                relayEnv: environment,
                cookieDomain: serverVars.get('cookieDomain'),
                userId,
            });
        } else {
            await setUserRegionalInfo({
                relayEnv: environment,
                cookieDomain: serverVars.get('cookieDomain'),
                userId,
            });
        }
    }
};
